import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'reactstrap';
import css from 'styled-jsx/css';

const { className: modalClass, styles: modalStyles } = css.resolve`
  @media (max-width: 767px) {
    .modal-dialog {
      height: 100%;
      width: 100%;
      max-height: 100%;
      max-width: 100%;
      margin: 0;
    }
  }
  @media (min-width: 768px) {
    .modal-dialog {
      height: 50%;
    }
  }
`;

function getModalContentCss(desktopHeight) {
  return css.resolve`
    @media (max-width: 767px) {
      .modal-content {
        border-radius: 0;
        height: 100% !important;
      }
    }
    @media (min-width: 768px) {
      .modal-content {
        border-radius: 1rem;
        height: ${desktopHeight};
      }
    }
  `;
}

export default function ModalLayout({
  backdrop = true,
  backdropClassName = '',
  centered = true,
  children,
  contentClassName = '',
  desktopHeight = '80vh',
  dialogClassName = '',
  isOpen = false,
  scrollable = false,
  size = 'lg',
  toggleModal,
  style = {},
}) {
  const { className: contentClass, styles: contentStyles } =
    getModalContentCss(desktopHeight);
  return (
    <Modal
      backdrop={backdrop}
      backdropClassName={backdropClassName}
      centered={centered}
      className={`${modalClass} ${dialogClassName}`}
      contentClassName={`${contentClass} ${contentClassName}`}
      isOpen={isOpen}
      scrollable={scrollable}
      size={size}
      toggle={toggleModal}
      style={style}
    >
      {children}
      {modalStyles}
      {contentStyles}
    </Modal>
  );
}

ModalLayout.propTypes = {
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['static'])]),
  backdropClassName: PropTypes.string,
  centered: PropTypes.bool,
  children: PropTypes.node,
  contentClassName: PropTypes.string,
  desktopHeight: PropTypes.string,
  dialogClassName: PropTypes.string,
  isOpen: PropTypes.bool,
  scrollable: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'lg', 'xl']),
  toggleModal: PropTypes.func,
  style: PropTypes.object,
};
